export default __webpack_public_path__ + "static/media/profession_manage_vanillJS.8996ab1c.PNG";